import "./CloseCaptionButton.css";

const CloseCaptionButton = ({
    onClick = () => {},
    isActive = false
}) => {

    return (
        <button className='btnCloseCaptions' onClick={onClick}>
            <span className={`btnCloseCaptions-content${isActive ? ' btnCloseCaptions-no-captions' : ''}`}>
                CC
            </span>
        </button>
    )
}

export default CloseCaptionButton;